// src/services/invoicesService.js
// Добавление фактуры «вместо водителя» — повторяет handleAddInvoice из Faktury.js (RTDB drivers/{driverId}/invoices).
import { ref as dbRef, push, set } from 'firebase/database';
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import moment from 'moment';

export const addInvoiceForDriver = async ({ storage, database, driverId, file }) => {
  if (!driverId) throw new Error('Brak driverId');
  if (!file) throw new Error('Brak pliku');

  const timestamp = Date.now();
  const ext = file.name.split('.').pop();
  const fileName = `${driverId}_${timestamp}.${ext}`;

  const fileRef = storageRef(storage, `invoice/${fileName}`);
  const uploadResult = await uploadBytes(fileRef, file);
  const fileURL = await getDownloadURL(uploadResult.ref);

  const invoiceData = {
    timestamp,
    status: 'W trakcie weryfikacji',
    addedBy: 'admin',
    fileURL,
    fileName,
    originalFileName: file.name,
    fileSize: file.size,
    uploadDate: moment().format('YYYY-MM-DD HH:mm:ss'),
  };

  const invoicesRef = dbRef(database, `/drivers/${driverId}/invoices`);
  const newInvoiceRef = push(invoicesRef);
  await set(newInvoiceRef, invoiceData);

  return { id: newInvoiceRef.key, ...invoiceData };
};
